
import HoverableCardOverlay from './RowCard';
import DiscardIcon from '../assets/images/discard.gif';
const { Table } = require('react-bootstrap');

// TakeMoves: card id -> the move that takes it, for cards the current player can take right now.
// TakenFromRow: slot -> card taken from it this turn; shown greyed out, and clicking it puts the card back
// (only for cards in RetractableCardIds: one that later moves depend on, e.g. a leader since elected, stays taken).
// Blocked: card id -> why the current player cannot take it (shown with a red border).
// CostNotes: card id -> its cost when the current player's cards change it (shown on hover).
function CardRow({Cards,PlayerCount,TakeMoves = {},OnTake,TakenFromRow = {},OnPutBack,Blocked = {},CostNotes = {},RetractableCardIds = []})
{
    if (Cards === null || Cards.length === 0)
    {
        return (<p>No Card Row</p>)
    }

    var CardElements = Cards.map((card, idx) => {
        var key = `card ${idx}`

        // (the card centred in its slot, under the ✗ that marks it for discarding: as much room below it as above)
        return <td key = {key} style = {{backgroundColor: GetBackgroundColor(idx), padding: '4px 2px 22px'}}>
            <div style = {{display: 'flex', justifyContent: 'center'}}>
            {/* Keyed by card so hover state belongs to the card, not the slot it happens to be in */}
            {card === null && TakenFromRow[idx]
                ? <HoverableCardOverlay
                    key = {`taken ${TakenFromRow[idx].id}`}
                    card = {TakenFromRow[idx]}
                    ghost
                    title = {RetractableCardIds.includes(TakenFromRow[idx].id)
                        ? "Taken this turn; click to put it back"
                        : "Taken this turn; can no longer be put back because later moves depend on it"}
                    onClick = {RetractableCardIds.includes(TakenFromRow[idx].id) ? () => OnPutBack(TakenFromRow[idx].id) : undefined} />
                : <HoverableCardOverlay key = {card?.id ?? `empty ${idx}`} card = { card } blocked = {card ? Blocked[card.id] : undefined} title = {card ? CostNotes[card.id] : undefined} onClick = {card && TakeMoves[card.id] ? () => OnTake(TakeMoves[card.id]) : undefined} />}
            </div>
        </td>
    })
    
    return (
        <Table borderless style={{width: '100%', borderRadius: '10px', overflow: 'hidden', userSelect:'none', marginBottom: 0}}>
            <tbody>
                <tr style={{padding:0, height: '18px', lineHeight: '18px'}}>
                    <td  style = {{backgroundColor: GetBackgroundColor(0), padding: 0}}/>
                    {new Array(13).fill().map((_, index) => {
                        if(index < 5-PlayerCount){
                            return <td key={`toprow${index}`} style = {{backgroundColor: GetBackgroundColor(index),height:'auto', padding:0}}><img src={DiscardIcon} alt="discarded" title="Removed from the card row at the start of the next turn" style={{height: '14px'}}/></td>
                        }else{
                            return <td key={`toprow${index}`} style = {{backgroundColor: GetBackgroundColor(index),height:'auto', padding:0}}></td>
                        }
                    })}
                    <td  style = {{backgroundColor: GetBackgroundColor(9), padding: '0 2px'}}/>
                </tr>
                <tr>
                    <td  style = {{backgroundColor: GetBackgroundColor(0), padding: '0 2px'}}/>
                    {CardElements}
                    <td  style = {{backgroundColor: GetBackgroundColor(9), padding: '0 2px'}}/>
                </tr>
            </tbody>
        </Table>
    )
}

function GetBackgroundColor(i)
{
    if (i<5) return "#ccc7c0";
    if (i<9) return "#b5aea8";
    return "#9c9790";
}

export default CardRow;